<template>
  <div class="current-address">
    <div class="__icon-wrapper">
      <i class="mc-icon icon-outline_live-view" />
    </div>
    <div class="__wrapper">
      <div class="__title">
        {{ $t('fleetTaskInstant.text.currentLocation') }}
      </div>
      <div class="__label">
        <b-skeleton-wrapper :loading="isLoading">
          <template #loading>
            <b-skeleton />
          </template>
          {{ address }}
        </b-skeleton-wrapper>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    address: {
      type: String,
      default: '-'
    },
    loading: {
      type: Boolean,
      required: true,
    }
  },
  computed: {
    isLoading() {
      return this.loading
    }
  }
}
</script>

<style lang="scss" scoped>
.current-address {
  background: $cyan-100;
  padding: 1rem;
  display: flex;
  gap: 10px;
  border-radius: 8px;
  border: 1px solid $teal-100;

  .__icon-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    background: $white;
    width: 40px;
    height: 40px;
    border-radius: 24px;
    padding: 10px;

    .mc-icon {
      font-size: 24px;
    }
  }

  .__wrapper {
    .__title {
      color: $mep-color-text;
      font-weight: 600;
    }

    .__label {
      font-size: 11px;
      color: $mep-color-text-300;
    }
  }
}
</style>